<template>
<div>
  <navbar>
  </navbar>
  <h3>Login</h3>
  <div class="mx-4">
    <alert :message="message" v-if="showMessage"></alert>
    <br>
    <b-form @submit="onSubmit" v-if="showform">
      <b-form-group>
        <b-row align-h="center" class="text-left">
          <b-col sm="2">
            <label for="input-workerID">Worker ID:</label>
          </b-col>
          <b-col sm="4">
            <b-form-input
              id="input-workerID"
              v-model="workerID"
              type="workerID"
              required
              placeholder="Enter workerID"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-button type="submit" class="rounded-pill m-5" variant="info">Login</b-button>
      <div>
        <p>Don't have an account? <router-link to="/signup">Sign Up!</router-link></p>
      </div>
    </b-form>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import Alert from '../Other/Alert.vue';
import Nav from '../Other/Nav.vue';

export default {
  name: 'Login',
  data() {
    return {
      workerID: '',
      message: '',
      showMessage: false,
      showform: true,
    };
  },
  components: {
    alert: Alert,
    navbar: Nav,
  },
  methods: {
    initForm() {
      this.workerID = '';
    },
    onSubmit(evt) {
      evt.preventDefault();
      const path = `${this.$hostname}/submit-login`;
      // const path = 'http://localhost:8080/submit-login';
      const payload = {
        workerID: this.workerID,
      };
      axios
        .post(path, payload)
        .then((res) => {
          if (res.data.status === 'success') {
            localStorage.clear();
            localStorage.userID = res.data.userID;
            localStorage.taskID = res.data.taskID;
            localStorage.workerID = res.data.workerID;
            localStorage.firstName = 'Friend!';
            localStorage.accountProgress = res.data.accountProgress;
            this.$router.push({ name: 'PageRender' });
          } else if (res.data.status === 'NotFound') {
            this.message = 'Wrong email or phone number';
            this.showMessage = true;
            this.initForm();
          } else {
            this.message = 'Error';
            this.showMessage = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
          this.message = 'Error';
          this.showMessage = true;
        });
    },
    // acceptNumber() {
    //   const x = this.form.phone_number
    //     .replace(/\D/g, '')
    //     .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    //   this.form.phone_number = !x[2]
    //     ? x[1]
    //     : `(${x[1]}) ${x[2]}${x[3] ? `-${x[3]}` : ''}`;
    // },
  },
};
</script>
